import React from 'react';

const Salaries = () => {
    return (
        <div className="bg-warning min-vh-100 p-4">
            dsadsad
        </div>
    );
};

export default Salaries;